import { Box, Theme, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../common/customTable'
import { AlternativeAssetTableProps, AssetAllocationTable, FundHouseComponentProps, FundHouseTable, TopFiveComponentProps, topFiveTableObj } from '../../../../redux-store/types/alternative'
import { SortingObj } from '../../types'
import _ from 'lodash'
import { FundHouseTableComponent, fundHouseTableHeader, TopFiveTableComponent, topFiveTableHeader } from './AlternativeTable'

function TopFiveComponent(props: TopFiveComponentProps) {

    const { isLoading, completeData, title } = props

    //state
    const [originTableData, setOriginTableData] = useState<Array<topFiveTableObj>>([])
    const [sortingObj, setSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: ""
    })

    useEffect(() => {
        if (completeData.length > 0) {
            setOriginTableData([...completeData])
        }
    }, [completeData])


    const handleTableSorting = (id: "schemeName" | "fundHouse" | "return" | "exposure", orderType: "asc" | "desc") => {
        setSortingObj({ order: orderType, orderBy: id })
        setOriginTableData(pre => {
            if (id === "schemeName") {
                return _.orderBy(pre, [(item) => item.schemeName.toLowerCase()], [orderType])
            } else if (id === 'fundHouse') {
                return _.orderBy(pre, [(item) => item.fundHouse.toLowerCase()], [orderType])
            } else {
                return _.orderBy(pre, [(item) => item[id]], [orderType === 'asc' ? 'desc' : 'asc'])
            }
        })

    }

    return (
        <Box sx={(theme: Theme) => ({
            borderRadius: '20px',
            padding: '25px 30px 45px 30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            background: theme.palette.common.white,
            height: '100%'
        })}>
            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography variant="h2" sx={{
                    marginBottom: '40px'
                }}>{title}</Typography>

            </Box>
            <Box mt={'20px'} width={'100%'}>
                <CustomTable
                    loadingRowsNum={3}
                    isLoading={isLoading}
                    tableBody={
                        <TopFiveTableComponent
                            tableBodyData={originTableData || []}
                            isLoading={isLoading}
                        />
                    }
                    tableData={originTableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },

                    }}
                    tableHeaderData={topFiveTableHeader}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handleTableSorting as any}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={originTableData?.length}
                    isPaginationVisible={false}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                />
            </Box>
        </Box>
    )
}

export default TopFiveComponent